import React from 'react'
// import BlogTrailSection  from '../../components/blog/BlogTrailSection'
// import LatestBlogSection from '../../components/blog/LatestBlogSection'
import BlogSection from '../../components/blog/BlogSection'

const Blog = () => {
  return (
    <div>
      {/* <BlogTrailSection/>
    <LatestBlogSection/> */}
    <BlogSection/>
    </div>
  )
}

export default Blog